import { useEffect } from 'react';
import { useGetOrgsQuery } from '../services/orgApi';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { setSelectedOrgId } from '../store/orgSlice';
import { Dropdown } from './ui';
import { apiSlice } from '../services/apiSlice';
import { iamApiSlice } from '../services/iamApiSlice';
import { creditApiSlice } from '../services/creditApiSlice';
import { orderkaroApiSlice } from '../services/orderkaroApiSlice';
import { paymentApi } from '../services/paymentApi';

export const OrganizationSwitcher = ({
  className = 'w-40',
}: {
  className?: string;
}) => {
  const { data: orgs, isLoading } = useGetOrgsQuery();
  const dispatch = useAppDispatch();
  const selectedOrgId = useAppSelector(state => state.org.selectedOrgId);

  // Auto-select when orgs load: always pick the only org, or first if none selected
  useEffect(() => {
    if (!orgs || orgs.length === 0) return;
    if (orgs.length === 1) {
      if (selectedOrgId !== orgs[0].id) {
        dispatch(setSelectedOrgId(orgs[0].id));
      }
      return;
    }
    if (!selectedOrgId) {
      dispatch(setSelectedOrgId(orgs[0].id));
    }
  }, [orgs, selectedOrgId, dispatch]);

  const resetAllCaches = () => {
    dispatch(iamApiSlice.util.resetApiState());
    dispatch(apiSlice.util.resetApiState());
    dispatch(creditApiSlice.util.resetApiState());
    dispatch(orderkaroApiSlice.util.resetApiState());
    dispatch(paymentApi.util.resetApiState());
  };

  const handleSelect = (value: string) => {
    if (value === selectedOrgId) return;
    dispatch(setSelectedOrgId(value));
    resetAllCaches();
  };

  if (isLoading) {
    return <div className={`h-9 animate-pulse rounded ${className}`} />;
  }

  // Hide switcher when user only belongs to one org
  if (!orgs || orgs.length <= 1) return null;

  const orgOptions = orgs.map(org => ({ label: org.name, value: org.id }));

  return (
    <div className={className}>
      <Dropdown
        items={orgOptions}
        value={selectedOrgId || ''}
        placeholder="Select Org"
        onSelect={handleSelect}
        size="sm"
        fullWidth
      />
    </div>
  );
};
